import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { API_INSTRUMENT_FILTER } from "../../utils/api/ApiConstant";
import { getAxios } from "../../Services/commonService";
import { Button, CustomSelect, Label } from "../";

const InstrumentFilter = ({ handleExchangeChange, handleDeleteRequest }) => {
  const [formData, setFormData] = useState({
    exchange: null,
  });

  const { isLoading, data: instrumentfilterExhangeListData } = useQuery({
    queryKey: ["instrumentfilterExhangeListData"],
    queryFn: async () =>
      await getAxios({
        url: API_INSTRUMENT_FILTER,
        params: {},
      }),
  });

  const exchangeListOptions =
    instrumentfilterExhangeListData?.exchangeList?.map((item) => ({
      value: item.exchangeName,
      label: item.exchangeName,
    })) || [];

  return (
    <div className="row" style={{ paddingRight: "11px", paddingLeft: "11px" }}>
      <div className="col-md-4">
        <CustomSelect
          options={exchangeListOptions}
          value={formData.exchange}
          onChange={(selectedOption) => {
            setFormData({ ...formData, exchange: { ...selectedOption } });
          }}
          placeholder="Select exchange"
          isMulti={false}
        />
      </div>
      <div className="col align-self-end mt-lg-3  mt-1">
        <div className="d-flex justify-content-end align-items-center ">
          <Button
            type="submit"
            className="btn-success mx-1"
            onClick={() => handleExchangeChange(formData.exchange.value)}
          >
            Search
          </Button>
          <Button
            type="button"
            onClick={() => {
              handleExchangeChange(null);
              setFormData({ ...formData, exchange: null });
            }}
            className="btn-danger"
          >
            Clear
          </Button>
          <Button
            type="button"
            onClick={() => handleDeleteRequest({ rowData: {} })}
            className="btn-danger"
          >
            Delete All
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InstrumentFilter;
